import { createLazyComponent, LazyModule, LazyModuleType } from 'owa-bundling';
import { ISkipLinkControl } from './components/SkipLinkControl';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SkipLinkControl"*/ './lazyIndex')
);

// Lazy-load components
export var SkipLinkControl = createLazyComponent<
    {},
    LazyModuleType<typeof lazyModule>,
    ISkipLinkControl
>(lazyModule, m => m.SkipLinkControl);
export { ISkipLinkControl };
export {
    default as SkipLinkPlaceholder,
    SkipLinkPlaceholderHandle,
} from './components/SkipLinkPlaceholder';
